import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import { CardBody, Badge } from "reactstrap";
import "./MenuItem.scss";
/**
 * Položka menu.
 */

class MenuItem extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    // název položky menu
    route: PropTypes.string.isRequired,
    // route pro přesměrování při kliknutí na položku
    active: PropTypes.bool.isRequired,
    // aktivní položka
    count: PropTypes.object, // počet nepřečtených
  };
  redirect = (route) => {
    this.props.history.push(route);
  };

  render() {
    const { active, name, route, count } = this.props;
    return (
      <CardBody className={`menu-item ${active ? "active" : ""}`} onClick={() => this.redirect(route)}>
        <div className="menu-item-container" title={name}>
          <div className="menu-item-name">{name}</div>
          {count && count.number > 0 && (
            <div className="menu-item-counter">
              <Badge
                style={{
                  background: count.color,
                }}
                pill
              >
                {count.number}
              </Badge>
            </div>
          )}
        </div>
      </CardBody>
    );
  }
}

export default withRouter(MenuItem);
